import useFadeIn from "./useFadeIn";
import {
    Box
} from '@mui/material';

// 각 섹션을 위한 FadeIn 컴포넌트
export default function FadeInSection({ children, delay = 0 }){
    const [ref, isVisible] = useFadeIn({ threshold: 0.2 });
    return (
      <Box
        ref={ref}
        sx={{
          transition: `opacity 1s ease-in-out ${delay}s, transform 0.7s ease-out ${delay}s`,
          opacity: isVisible ? 1 : 0,
          transform: isVisible ? 'translateY(0)' : 'translateY(40px)',
        }}
      >
        {children}
      </Box>
    );
  };